module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/log/log.component.css
// module id = ./src/app/views/log/log.component.css
// module chunks = main